
import $ from 'jquery';
import Component from './component';
import { HeaderPanelActionType } from '../constant/actionType';
import createComponentFactory from '../createComponent';


class Page extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.$element = $(element);
    this.$window = $(window);
    this.$bar = $('.l-pageHeaderCompact__bar');
    this.$nav = $('.l-pageHeaderCompact__nav');

    this._handleShowHeaderPanel = this._handleShowHeaderPanel.bind(this);
    this._handleHideHeaderPanel = this._handleHideHeaderPanel.bind(this);
    this._handleSplashComplete = this._handleSplashComplete.bind(this);
  }

  _addEvents() {
    this.context.dispatcher.on(HeaderPanelActionType.SHOW_HEADER_PANEL, this._handleShowHeaderPanel);
    this.context.dispatcher.on(HeaderPanelActionType.HIDE_HEADER_PANEL, this._handleHideHeaderPanel);

    this.context.dispatcher.on('splashComplete', this._handleSplashComplete);
  }

  _removeEvents() {
    this.context.dispatcher.off(HeaderPanelActionType.SHOW_HEADER_PANEL, this._handleShowHeaderPanel);
    this.context.dispatcher.off(HeaderPanelActionType.HIDE_HEADER_PANEL, this._handleHideHeaderPanel);

    this.context.dispatcher.off('splashComplete', this._handleSplashComplete);
  }

  _handleSplashComplete() {
    this.element.classList.add('is-sprite-completed');
  }

  _handleShowHeaderPanel() {
    this.scrollTop = this.$window.scrollTop();

    let offset = this.$bar.outerHeight() - this.scrollTop;

    this.$element.css({
      position: 'fixed',
      top: - this.scrollTop
    });

    this.$nav.css({
      top: (offset > 0 ? offset : 0)
    })
  }

  _handleHideHeaderPanel() {
    this.$element.css({
      position: '',
      top: 0
    });

    this.$window.scrollTop(this.scrollTop);
  }

  didRegisterComponent() {
    this._addEvents();
  }

  didUnregisterComponent() {
    this._removeEvents();
  }
}


export default createComponentFactory(Page);



// WEBPACK FOOTER //
// ./src/js/app/component/page.js